jQuery(document).ready(function ($) {
	if ($("#bodyshop-details").length === 0)
		return;
	$(".compliance").compliance();
});